// ── 연차 관리 스타일 파트B (뱃지·페이지네이션·버튼·폼·모달·시트) ────────────────

// 뱃지
export const countBadgeStyle = {
  display: 'inline-block',
  background: 'var(--bg-subtle)',
  color: 'var(--text-sub)',
  borderRadius: 999,
  padding: '1px 6px',
  fontSize: 12,
  fontWeight: 700,
};
export const correctionBadgeStyle = {
  display: 'inline-block',
  background: '#fef9c3',
  color: '#854d0e',
  borderRadius: 999,
  padding: '2px 8px',
  fontSize: 11,
  fontWeight: 700,
};
export const normalBadgeStyle = {
  display: 'inline-block',
  background: 'var(--bg-subtle)',
  color: 'var(--text-muted)',
  borderRadius: 999,
  padding: '2px 8px',
  fontSize: 11,
  fontWeight: 600,
};
export const reasonCellStyle = {
  maxWidth: 240,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

// 페이지네이션
export const paginationStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 10,
  paddingTop: 2,
};
export const pageInfoStyle = {
  color: 'var(--text-muted)',
  fontWeight: 700,
  fontSize: 13,
};

// 버튼
const baseBtn = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '4px 10px',
  cursor: 'pointer',
  fontWeight: 700,
  fontSize: 12,
  whiteSpace: 'nowrap',
};
export const outlineBtn = {
  ...baseBtn,
  background: 'var(--bg-card)',
  color: 'var(--text-sub)',
};
export const primaryBtn = {
  ...baseBtn,
  background: '#6366f1',
  borderColor: '#6366f1',
  color: '#fff',
};
export const dangerOutlineBtn = {
  ...baseBtn,
  background: 'var(--bg-card)',
  color: '#dc2626',
  borderColor: '#fecaca',
};

// 폼
export const inputStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '5px 10px',
  fontSize: 13,
  color: 'var(--text-sub)',
  background: 'var(--bg-card)',
  width: '100%',
  boxSizing: 'border-box',
};
export const formGridStyle = {
  display: 'grid',
  gap: 6,
  gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
};
export const formLabelStyle = {
  fontSize: 12,
  fontWeight: 700,
  color: 'var(--text-sub)',
};
export const formErrorStyle = {
  fontSize: 12,
  color: '#dc2626',
};

// 신규 추가 모달 섹션
export const modalSectionStyle = {
  borderTop: '1px solid var(--bg-subtle)',
  paddingTop: 8,
};
export const modalSectionTitleStyle = {
  fontSize: 13,
  fontWeight: 800,
  color: 'var(--text-sub)',
  marginBottom: 6,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
};
export const modalSectionCountStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#6366f1',
  color: '#fff',
  borderRadius: 999,
  padding: '1px 8px',
  fontSize: 11,
  fontWeight: 700,
};

// 직원 선택 재직중/전체 토글 버튼
export const pickerToggleBtn = (active) => ({
  border: 'none',
  borderRadius: 6,
  padding: '2px 8px',
  cursor: 'pointer',
  fontWeight: active ? 700 : 500,
  fontSize: 12,
  background: active ? 'var(--bg-card)' : 'transparent',
  color: active ? 'var(--text-sub)' : 'var(--text-muted)',
});

// 직원 선택 그리드 (신규 추가 모달)
export const employeeGridStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 4,
  padding: '4px 0 2px',
};

// 직원 버튼 칩 — isSelected 여부에 따라 스타일 전환
export const employeeChipBtnStyle = (isSelected) => ({
  border: isSelected ? '1.5px solid #6366f1' : '1px solid var(--border)',
  borderRadius: 999,
  padding: '3px 10px',
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: isSelected ? 700 : 500,
  background: isSelected ? '#6366f1' : 'var(--bg-subtle)',
  color: isSelected ? '#fff' : 'var(--text-sub)',
  transition: 'all 0.12s',
  whiteSpace: 'nowrap',
});

// 고정 개수 표시 (연차/반차/경조사)
export const fixedCountDisplayStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '5px 10px',
  fontSize: 13,
  fontWeight: 700,
  color: 'var(--text-sub)',
  background: 'var(--bg-subtle)',
  display: 'flex',
  alignItems: 'center',
};

// 미리보기 뱃지 (신규 추가 모달 하단)
export const previewBadgeStyle = {
  background: '#eff6ff',
  border: '1px solid #bfdbfe',
  borderRadius: 10,
  padding: '6px 12px',
  fontSize: 13,
  color: 'var(--text-sub)',
  textAlign: 'center',
  fontWeight: 600,
};

// 대량 붙여넣기 모달
export const guideBoxStyle = {
  padding: '10px 14px',
  borderRadius: 10,
  border: '1px solid var(--border)',
  background: 'var(--bg-subtle)',
};
export const sheetWrapStyle = {
  overflow: 'auto',
  border: '1px solid var(--border)',
  borderRadius: 10,
  maxHeight: '55vh',
  background: 'var(--bg-card)',
};
export const sheetTableStyle = {
  width: 'max-content',
  minWidth: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
};
export const sheetIndexHeaderStyle = {
  position: 'sticky', left: 0, top: 0, zIndex: 3,
  background: 'var(--bg-subtle)', minWidth: 46,
  borderBottom: '1px solid var(--border)',
  borderRight: '1px solid var(--border)',
  padding: '8px',
  fontSize: 12, fontWeight: 700, color: 'var(--text-muted)',
};
export const sheetHeaderStyle = {
  position: 'sticky', top: 0, zIndex: 2,
  background: 'var(--bg-subtle)', minWidth: 150,
  borderBottom: '1px solid var(--border)',
  borderRight: '1px solid var(--border)',
  padding: '8px 10px',
  textAlign: 'left',
  fontSize: 12, fontWeight: 700, color: 'var(--text-sub)',
};
export const sheetIndexCellStyle = {
  position: 'sticky', left: 0, zIndex: 1,
  background: 'var(--bg-subtle)',
  textAlign: 'center', fontWeight: 600,
  borderRight: '1px solid var(--border)',
  borderBottom: '1px solid var(--border)',
  padding: '0 8px',
  fontSize: 12, color: 'var(--text-muted)',
};
export const sheetCellStyle = {
  borderRight: '1px solid var(--border)',
  borderBottom: '1px solid var(--border)',
  padding: 0,
  background: 'var(--bg-card)',
};
export const sheetInputStyle = {
  width: '100%', minWidth: 150, height: 36,
  border: 'none', outline: 'none',
  padding: '6px 10px', fontSize: 13, background: 'var(--bg-card)',
};
export const errorInputStyle = {
  ...sheetInputStyle,
  background: '#fff1f2',
  boxShadow: 'inset 0 0 0 1px #ef4444',
};
